<section>
  <figure class="logo">
    <img src="assets/img/intro/logo-with-text.png" alt="DABubble-Logo" (click)="goToAuth()"/>
  </figure>
  <div class="main-container">
    <div class="inner-container">
      <div class="inner-container-content">
        <div class="arrow-container" (click)="goBack()">
          <img src="assets\icons\arrow_back.svg" alt="back" />
        </div>
        <div class="text-container">
          <div class="text-container-one">
            <h2>Impressum</h2>
            <p>Mark Corzilius, Cecilia D, Davor Jezernik, Phillip Schuster</p>
            <p>Schönaugürtel 7</p>
            <p>8010 Graz</p>
          </div>
          <div class="text-container-two">
            <h2>Kontakt:</h2>
            <p>Email: dev&#64;davorjezernik.com</p>
            <p>Email: marccorzprivate@gmail.com</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
